import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalendarAlt,
  faCalendarCheck,
  faCrown,
  faIdBadge,
  faUserClock,
  faUsers,
  faSignOutAlt,
  faSync,
} from '@fortawesome/free-solid-svg-icons';

import { Container, Menu, MenuIcon } from './styles';

const menuItems = [
  { name: 'Administradores', path: '/admin/dashboard/administrators', icon: faCrown },
  { name: 'Eventos', path: '/admin/dashboard/events', icon: faCalendarAlt },
  { name: 'Divulgadores', path: '/admin/dashboard/promoters', icon: faUsers },
  { name: 'Produtores', path: '/admin/dashboard/producers', icon: faIdBadge },
  { name: 'Atualização de seguidores', path: '/admin/dashboard/update-followers', icon: faSync },
  { name: 'Eventos pendentes', path: '/admin/dashboard/pending-events', icon: faCalendarCheck },
  { name: 'Divulgadores pendentes', path: '/admin/dashboard', icon: faUserClock },
];

export default class Sidebar extends Component {
  state = {
    menuActive: false,
  };

  handleLogout = (e) => {
    e.preventDefault();

    window.localStorage.removeItem('token_admin');
    window.location.href = '/admin';
  };

  toggleMenu = () => {
    this.setState(prevState => ({
      menuActive: !prevState.menuActive,
    }));
  }

  render() {
    const { menuActive } = this.state;

    return (
      <Fragment>
        <MenuIcon onClick={() => this.toggleMenu()}>
          <div className="bar" />
          <div className="bar" />
          <div className="bar" />
        </MenuIcon>
        <Container className={`main-sidebar ${menuActive ? 'active' : ''}`}>
          <Menu onClick={() => this.toggleMenu()}>
            {menuItems.map(item => (
              <li key={item.name}>
                <Link to={item.path}>
                  <span className="item-icon">
                    <FontAwesomeIcon icon={item.icon} />
                  </span>
                  <span className="item-name">{item.name}</span>
                </Link>
              </li>
            ))}
            <li>
              <a href="/logout" onClick={this.handleLogout}>
                <span className="item-icon">
                  <FontAwesomeIcon icon={faSignOutAlt} />
                </span>
                <span className="item-name">Sair</span>
              </a>
            </li>
          </Menu>
        </Container>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/Sidebar/index.js